import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import LatestUpdateSection from './components/LatestUpdateSection';
import CategoryNavSection from './components/CategoryNavSection';
import RankingSection from './components/RankingSection';

export default function Home() {
  const homepageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '蜜桃少年漫画-漫画在线免费阅读-073漫画网',
    description: '在073漫画网，体验蜜桃少年漫画在线免费阅读的轻松，随时随地继续您的漫画之旅。海量少年漫画资源，高清画质流畅阅读。',
    url: 'http://tangcruises.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '073漫画网',
      url: 'http://tangcruises.com/',
    },
    about: {
      '@type': 'Thing',
      name: '少年漫画',
      description: '073漫画网提供蜜桃少年漫画等热门少年漫画的在线免费阅读服务',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homepageJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendSection />
          <LatestUpdateSection />
          <CategoryNavSection />
          <RankingSection />
        </main>
        <Footer />
      </div>
    </>
  );
}